import { post, axiosErrorHandler } from 'models/shared/helpers/axiosInstance';
import { PalencaRefreshResult } from '../interfaces/palenca.interface';

export const refreshPalencaStatus = async (
	ozonerId: string,
): Promise<PalencaRefreshResult> => {
	try {
		const res = await post<PalencaRefreshResult>(
			`/v1/palenca/refresh/${ozonerId}`,
		);

		return res.data;
	} catch (err: any) {
		throw axiosErrorHandler(err);
	}
};
